// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","3071":"54245876","7032":"d8e21cd0","9103":"b9ea4917"}[chunkId] + ".css";
};